const c = {
  name: "TerminalFleetManager",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M3,0C1.3,0,0,1.3,0,3v8c0,1.7,1.3,3,3,3h4c1.7,0,3-1.3,3-3V3c0-1.7-1.3-3-3-3H3z M2,3c0-0.6,0.4-1,1-1h4
			c0.6,0,1,0.4,1,1v3H2V3z M2,8h6v3c0,0.6-0.4,1-1,1H3c-0.6,0-1-0.4-1-1V8z"/>
		<path class="st0" d="M2,16v2h6v-2H2z"/>
		<path class="st0" d="M15,3c0-1.7,1.3-3,3-3h4c1.7,0,3,1.3,3,3v8c0,1.7-1.3,3-3,3h-4c-1.7,0-3-1.3-3-3V3z M18,2c-0.6,0-1,0.4-1,1v3
			h6V3c0-0.6-0.4-1-1-1H18z M23,8h-6v3c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1V8z"/>
		<path class="st0" d="M17,16v2h6v-2H17z"/>
		<path class="st0" d="M30,3c0-1.7,1.3-3,3-3h4c1.7,0,3,1.3,3,3v8c0,1.7-1.3,3-3,3h-4c-1.7,0-3-1.3-3-3V3z M33,2c-0.6,0-1,0.4-1,1v3
			h6V3c0-0.6-0.4-1-1-1H33z M38,8h-6v3c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1V8z"/>
		<path class="st0" d="M32,16v2h6v-2H32z"/>
		<path class="st0" d="M0,25c0-1.7,1.3-3,3-3h4c1.7,0,3,1.3,3,3v8c0,1.7-1.3,3-3,3H3c-1.7,0-3-1.3-3-3V25z M3,24c-0.6,0-1,0.4-1,1v3
			h6v-3c0-0.6-0.4-1-1-1H3z M2,30v3c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1v-3H2z"/>
		<path class="st0" d="M2,38v2h6v-2H2z"/>
		<path class="st0" d="M15,25c0-1.7,1.3-3,3-3h4c1.7,0,3,1.3,3,3v8c0,1.7-1.3,3-3,3h-4c-1.7,0-3-1.3-3-3V25z M18,24
			c-0.6,0-1,0.4-1,1v3h6v-3c0-0.6-0.4-1-1-1H18z M17,30v3c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1v-3H17z"/>
		<path class="st0" d="M17,38v2h6v-2H17z"/>
		<path class="st0" d="M30,25c0-1.7,1.3-3,3-3h4c1.7,0,3,1.3,3,3v8c0,1.7-1.3,3-3,3h-4c-1.7,0-3-1.3-3-3V25z M33,24
			c-0.6,0-1,0.4-1,1v3h6v-3c0-0.6-0.4-1-1-1H33z M32,30v3c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1v-3H32z"/>
		<path class="st0" d="M32,38v2h6v-2H32z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as TerminalFleetManager
};
